(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mobile-hero-playback')) {
  customElements.define('mobile-hero-playback', class extends HTMLElement {
    connectedCallback() {
      this.video = this.closest('.hero').querySelector('[data-testid="hero-mobile-video-1"]');
      this.button = this.querySelector('button');
      if (!this.video) { this.hidden = true; return; }
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.sync = () => {
        this.toggleAttribute('data-paused', this.video.paused);
        this.button.setAttribute('aria-label', this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      };
      this.button.addEventListener('click', () => {
        if (this.video.paused) this.video.play().catch(this.sync);
        else this.video.pause();
      }, { signal });
      this.video.addEventListener('play', this.sync, { signal });
      this.video.addEventListener('pause', this.sync, { signal });
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.video.autoplay = false;
        this.video.pause();
      }
      this.sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
if (!customElements.get('single-mobile-purchase')) {
  customElements.define('single-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.addEventListener('change', event => {
        if (event.target.matches('[data-purchase-colour]')) {
          const url = new URL(event.target.value, window.location.origin);
          if (url.origin === window.location.origin) window.location.assign(url.href);
        }
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
